export default __webpack_public_path__ + "static/media/Starlight.1aadd78b.png";